import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "unit-toggle",
  class UnitToggle extends WYATTElement {
    constructor() {
      super();

      const selectedUnit = localStorage.getItem("unit") ?? "imperial";
      this.inputs = this.querySelectorAll("input[type='radio']");
      this.unitContainers = this.querySelectorAll("[data-unit]");

      this.inputs?.forEach((input) => {
        if (input.value === selectedUnit) input.checked = true;
        input.addEventListener("change", this.handleInputChange.bind(this));
      });

      this.subscribe(
        WYATT.PubSub.events.changeUnit,
        this.handleSubscribe.bind(this),
      );

      this.toggleUnit(selectedUnit);
    }

    handleInputChange(event) {
      const { value, checked } = event.target;

      if (!checked) return;

      this.toggleUnit(value, true);
      localStorage.setItem("unit", value);
    }

    handleSubscribe({ detail }) {
      this.toggleUnit(detail.value);
    }

    toggleUnit(value, publish = false) {
      this.unitContainers.forEach((input) => {
        input.classList.toggle("hidden", input.dataset.unit !== value);
      });

      if (publish) {
        this.publish(WYATT.PubSub.events.changeUnit, { value });
      }
    }
  },
);
